import { render, staticRenderFns } from "./Depot.vue?vue&type=template&id=031c9916"
import script from "./Depot.vue?vue&type=script&lang=js"
export * from "./Depot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports